import { FC } from 'react';
import { Link, useLocation } from '@tanstack/react-router';
import { Pencil } from 'lucide-react';

interface EditButtonProps {
  path?: string;
}

export const EditButton: FC<EditButtonProps> = ({ path }) => {
  const location = useLocation();

  if (location.pathname.endsWith('/edit')) {
    return null;
  }

  const to = path || `${location.pathname}/edit`;
  return (
    <Link
      to={to}
      className="absolute top-5 right-7 z-50 flex items-center bg-(--neutral-white-NW1000)! justify-center w-10 h-10 rounded-full text-(--neutral-white-NW1000) shadow-lg cursor-pointer"
    >
      <Pencil size={20} className="hover:text-(--primary-O900)" />
    </Link>
  );
};
